export enum AcceptButtonStatus {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  LOADING = 'loading',
}
